import {Dialog, DialogContent} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import RateContent from "./RateContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const RateContainerView = ({rateId, open, setOpen}: { rateId: number | null, open: boolean, setOpen: Function }) => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    return (
        <Dialog
            open={open}
            keepMounted
            maxWidth={"xl"}
            fullWidth
            onClose={() => {
                setOpen(false);
            }}
        >
            <DialogTitle sx={{m: 0, p: 2}}>
                {t("pricing:rates.sections.rate")}
                <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500]
                    }}
                >
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{padding: 0}}>
                <RateContent readOnly={true} rateId={rateId} open={open}/>
            </DialogContent>
        </Dialog>
    );
};

export default RateContainerView;